import { get } from "lodash";
import { AVAILABLE_SOURCES } from "utils/api/graphql/queries/sources";
import {
  sourceOptions,
  isOpenSource,
  NO_SOURCE_VALUE,
} from "utils/helpers/sources";

export { NO_SOURCE_VALUE };

/**
 * Remote option lists for `select[data-options-source="<key>"]`. Each entry
 * resolves `[{ value, label, isDefault? }]` from `{ client, project, labels }`.
 * `isDefault` marks the option shown while the bound value is empty.
 */
export const optionSources = {
  processSources: async ({ client, project, labels }) => {
    const { data } = await client.query({
      query: AVAILABLE_SOURCES,
      variables: { where: {} },
      fetchPolicy: "network-only",
    });
    return sourceOptions({
      sources: get(data, "sources.data", []).filter((source) =>
        isOpenSource(source),
      ),
      current: get(project, "source") || null,
      noSourceLabel: get(labels, "NO_SOURCE", ""),
    }).map((option) =>
      option.value === NO_SOURCE_VALUE
        ? { ...option, isDefault: true }
        : option,
    );
  },
};

export const loadSourceOptions = (source, context) => {
  const load = optionSources[source];
  return load ? load(context) : Promise.resolve([]);
};
